import { round } from './number';

/**
 * Computes tight fitting viewbox for SVG
 *
 * @param svg SVG string
 * @param useOriginalViewBox If true, returns the original viewbox from the SVG if it exists
 * @returns viewbox '0 0 0 0' string
 */
const computeSvgViewBox = (svg: string, useOriginalViewBox?: boolean) => {
  const div = document.createElement('div');
  div.innerHTML = svg;

  document.body.appendChild(div);

  const svgElement = div.querySelector('svg');
  const box = (svgElement as SVGGraphicsElement)?.getBBox();

  div.remove();

  if (!box || !svgElement) {
    return '';
  }

  const svgHasNestedSvg = checkifSvgHasNestedSvg(svg);

  // Temporary workaround for Icons8 illustrations that contain nested svg elements within g containers, only scoped to known ids
  if (useOriginalViewBox && svgElement.getAttribute('viewBox') && svgHasNestedSvg) {
    return svgElement.getAttribute('viewBox') as string;
  }

  return [round(box.x), round(box.y), round(box.width), round(box.height)].join(' ');
};

const checkifSvgHasNestedSvg = (svg: string): boolean => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(svg, 'image/svg+xml');
  const gElements = doc.querySelectorAll('g');

  for (const gElement of gElements) {
    if (gElement.querySelector('svg')) {
      return true;
    }
  }

  return false;
};

export { checkifSvgHasNestedSvg, computeSvgViewBox };
